import SalesJobServiceMutator from './SalesJobServiceMutator';
import RefreshAction from './actions/RefreshAction';
import RetryAction from './actions/RetryAction';
import Attributes from './attributes/PluginSetup';
function install(molten) {
  molten.addPlugin('OpenApiMutator', SalesJobServiceMutator);
  molten.addPlugin('Action', RetryAction);
  molten.addPlugin('Action', RefreshAction);
  Attributes.install(molten);
}
export default {
  install
};